// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"522d57e2","239":"932ac8dd","453":"f29da7e5","455":"956c2ce8","977":"d8aa82c5"}[chunkId] + ".chunk.js";
};